import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="container-site py-14 md:py-18">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center text-xl">
                <i className="ri-drop-fill text-primary-400"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                黄油作坊
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60">
              专注手工黄油制作的创意空间，从原料选择到风味创作，与你分享纯天然黄油的一切美好。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              内容分类
            </h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/category/shougong-huangyou-jiaocheng"
                  className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  新手入门
                </Link>
              </li>
              <li>
                <Link
                  to="/category/kai-dian-zhinan"
                  className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  创业指南
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              联系方式
            </h4>
            <ul className="flex flex-col gap-2.5 text-sm text-background-50/60">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>hello@huangyouzuofang.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-400"></i>
                <span>上海市静安区南京西路1688号</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-400"></i>
                <span>021-5888-6666</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/50">
            &copy; {currentYear} 黄油作坊 HuangYouZuoFang. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-fill text-lg"></i>
            </a>
            <a href="#" className="text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-fill text-lg"></i>
            </a>
            <a href="#" className="text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer" aria-label="小红书">
              <i className="ri-red-packet-fill text-lg"></i>
            </a>
            <a href="#" className="text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer" aria-label="B站">
              <i className="ri-bilibili-fill text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}